"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IProduct from "@/interfaces/product.interface";
import productService from "@/services/product.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetProductByIdReturn = RequestsBaseReturn<IProduct | null>;

export type UseGetProductByIdProps = ByIdRequestProps & {
  enabled?: boolean;
};

type UseSwrGetProductByIdParams = [string, number] | null;

const useGetProductById = ({
  _id,
  enabled = true,
}: UseGetProductByIdProps): UseGetProductByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IProduct, Error, UseSwrGetProductByIdParams>(
    enabled && _id ? [SWR_KEYS.getProductById, _id] : null,
    ([, userId]) => productService.getById(userId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetProductById;
